import { getScriptParam } from './get-url-param.js';
import onStartConversation from '../adapters/on-start-conversation.js';
import onDomReady from '../adapters/on-dom-ready.js';
import resetSesionAdapter from '../adapters/reset-session.js';
import openChatbotAdapter from '../adapters/open-chatbot.js';
import '../adapters/salesforce-liveagent-adapter.js';
import markingAdapter from '../adapters/marking-adapter.js';

export default (app, openChatOnBuild) => {

  let live = getScriptParam('live');
  if (!live || live !== 'keepcon') live = 'inbenta';

  app.sdkConfig.adapters =
    typeof app.sdkConfig.adapters !== 'undefined' ? app.sdkConfig.adapters : [];

  app.sdkConfig.adapters.push(
    onDomReady(),
    markingAdapter(),
    onStartConversation(app, live),
    resetSesionAdapter(),
    openChatbotAdapter(),
  );

  // Add Salesforce adapter if chat is active
  app.sdkConfig.adapters[app.sdkConfig.adapters.length] = window.salesforceLiveAgentAdapter(app.sdkConfig.environment, app.appConfig.salesforceConf);

  // Update config based on certain parameters
  if (window.location.hostname.indexOf('chat.') !== -1) {
    app.sdkConfig.autoDisplaySideWindow = false;
  }

  // Build SDK
  window.InbentaChatbotSDK.buildWithDomainCredentials(
    app.sdkAuth,
    app.sdkConfig
  );

  if (openChatOnBuild) {
    window.openChatbot();
  }
};
